import React, { useEffect } from 'react';
import {
  Container,
  Paper,
  Box,
  Typography,
  Stack,
  Fade,
  IconButton,
  useTheme,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import GetAppIcon from '@mui/icons-material/GetApp';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import { BilldaLogo, parseToken } from '@billda/shared-ui';
import { useAuthStore } from '../../features/auth/stores/authStore';

const APP_STORE_URL = 'https://apps.apple.com/us/app/billda/id6754762626';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.billda.mobile';
const APP_STORE_ID = '6754762626';

const SOCIAL_LINKS = [
  {
    href: 'https://www.linkedin.com/company/billdaltd/',
    label: 'LinkedIn',
    path: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
  },
  {
    href: 'https://www.instagram.com/billdaltd?igsh=Y3htZWkzMG10cHpm&utm_source=qr',
    label: 'Instagram',
    path: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z',
  },
  {
    href: 'https://www.facebook.com/share/17HmpUBwAC/?mibextid=wwXIfr',
    label: 'Facebook',
    path: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z',
  },
  {
    href: 'https://www.tiktok.com/@billdaltd?_r=1&_t=ZN-946ZSWn2qz0',
    label: 'TikTok',
    path: 'M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z',
  },
];

const STEP_ICONS = [
  GetAppIcon,
  EmailOutlinedIcon,
  LocationOnOutlinedIcon,
  RocketLaunchOutlinedIcon,
] as const;

const STEPS = [
  {
    title: 'Download the app',
    getDescription: () => 'Get Billda from the App Store or Google Play above',
  },
  {
    title: 'Sign in with your email',
    getDescription: (email: string) =>
      email ? `Use ${email} to log in` : 'Use the email you were invited with',
  },
  {
    title: 'Get assigned to a site',
    getDescription: () =>
      'Ask your organisation owner to assign you to a site and labour',
  },
  {
    title: 'Start working',
    getDescription: () =>
      "You'll see your sites and bookings once you're logged in",
  },
] as const;

/** Official "Download on the App Store" badge (Apple design guidelines) */
const AppStoreBadge: React.FC = () => (
  <svg
    viewBox="0 0 120 40"
    width={150}
    height={50}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Download on the App Store"
  >
    <title>Download on the App Store</title>
    <rect width="120" height="40" rx="6" fill="#000" />
    <rect
      x=".5"
      y=".5"
      width="119"
      height="39"
      rx="5.5"
      stroke="#A6A6A6"
      strokeWidth=".4"
      fill="none"
    />
    <g fill="#fff">
      <path d="M24.77 20.3a4.95 4.95 0 0 1 2.36-4.15 5.07 5.07 0 0 0-3.99-2.16c-1.68-.18-3.31 1.01-4.17 1.01-.87 0-2.2-.99-3.63-.96a5.33 5.33 0 0 0-4.49 2.74c-1.93 3.34-.49 8.27 1.36 10.97.93 1.33 2.02 2.81 3.45 2.76 1.39-.06 1.92-.89 3.6-.89 1.68 0 2.16.89 3.62.86 1.5-.03 2.44-1.33 3.33-2.67a11.05 11.05 0 0 0 1.52-3.09 4.78 4.78 0 0 1-2.96-4.42Z" />
      <path d="M22.04 12.21a4.87 4.87 0 0 0 1.12-3.5 4.96 4.96 0 0 0-3.21 1.66 4.64 4.64 0 0 0-1.15 3.36 4.1 4.1 0 0 0 3.24-1.52Z" />
    </g>
    <g fill="#fff">
      <text
        x="42"
        y="14"
        fontSize="5.2"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontWeight="400"
        letterSpacing=".03em"
      >
        Download on the
      </text>
      <text
        x="42"
        y="27"
        fontSize="11"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontWeight="600"
        letterSpacing="-.02em"
      >
        App Store
      </text>
    </g>
  </svg>
);

/** Official "Get it on Google Play" badge */
const GooglePlayBadge: React.FC = () => (
  <svg
    viewBox="0 0 135 40"
    width={168}
    height={50}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Get it on Google Play"
  >
    <title>Get it on Google Play</title>
    <rect width="135" height="40" rx="6" fill="#000" />
    <rect
      x=".5"
      y=".5"
      width="134"
      height="39"
      rx="5.5"
      stroke="#A6A6A6"
      strokeWidth=".4"
      fill="none"
    />
    {/* Play triangle icon */}
    <g transform="translate(10, 5.5)">
      <defs>
        <linearGradient id="gp-a" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#00A0FF" />
          <stop offset="100%" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient id="gp-b" x1="0" y1=".5" x2="1" y2=".5">
          <stop offset="0%" stopColor="#FFE000" />
          <stop offset="100%" stopColor="#FFA500" />
        </linearGradient>
        <linearGradient id="gp-c" x1="1" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FF3A44" />
          <stop offset="100%" stopColor="#C31162" />
        </linearGradient>
        <linearGradient id="gp-d" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stopColor="#32A071" />
          <stop offset="100%" stopColor="#2DA771" />
        </linearGradient>
      </defs>
      <path
        d="M1.3.5C1 .8.9 1.3.9 1.8v25.4c0 .6.1 1 .4 1.3l.1.1L15.6 14.5v-.3L1.3.5Z"
        fill="url(#gp-a)"
      />
      <path
        d="M20.4 19.3l-4.8-4.8v-.3l4.8-4.8.1.1 5.7 3.2c1.6.9 1.6 2.4 0 3.4l-5.8 3.2Z"
        fill="url(#gp-b)"
      />
      <path
        d="M20.5 19.2L15.6 14.3 1.3 28.5c.5.6 1.4.6 2.4.1l16.8-9.4Z"
        fill="url(#gp-c)"
      />
      <path
        d="M20.5 9.5L3.7.2C2.7-.4 1.8-.3 1.3.2l14.3 14.1 4.9-4.8Z"
        fill="url(#gp-d)"
      />
    </g>
    <g fill="#fff">
      <text
        x="39"
        y="14"
        fontSize="5"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontWeight="400"
        letterSpacing=".06em"
      >
        GET IT ON
      </text>
      <text
        x="39"
        y="27"
        fontSize="10.5"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontWeight="500"
        letterSpacing="-.01em"
      >
        Google Play
      </text>
    </g>
  </svg>
);

const DownloadAppPage: React.FC = () => {
  const theme = useTheme();
  const token = useAuthStore(state => state.token);
  const parsed = parseToken(token);
  const firstName = parsed?.firstName || '';
  const email = parsed?.email || '';
  const orgName = parsed?.currentOrganisationName;
  const isDark = theme.palette.mode === 'dark';

  // iOS Smart App Banner — Safari shows a native "OPEN" / "VIEW" banner
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'apple-itunes-app';
    meta.content = `app-id=${APP_STORE_ID}`;
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  const gradientBg = isDark
    ? 'linear-gradient(180deg, rgba(2,0,36,1) 0%, rgba(10,14,24,1) 35%, rgba(12,18,28,1) 100%)'
    : 'linear-gradient(180deg, rgba(245,248,255,1) 0%, rgba(236,244,255,1) 40%, rgba(255,255,255,1) 100%)';

  const glassStyles = {
    px: { xs: 3, md: 4 },
    py: { xs: 4, md: 6 },
    borderRadius: 3,
    border: '1px solid',
    borderColor: 'divider',
    backdropFilter: 'blur(10px)',
    backgroundColor: isDark
      ? 'rgba(20, 24, 35, 0.65)'
      : 'rgba(255, 255, 255, 0.7)',
    width: '100%',
    mx: 'auto',
  } as const;

  const heading = firstName
    ? `You're all set, ${firstName}!`
    : "You're all set!";

  const message = orgName
    ? `You've been added to ${orgName}. Download the Billda app to get started.`
    : 'Your account is ready. Download the Billda app to get started.';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'stretch',
        background: gradientBg,
        position: 'relative',
        left: '50%',
        right: '50%',
        marginLeft: '-50vw',
        marginRight: '-50vw',
        width: '100vw',
      }}
      data-testid="download-app-page"
    >
      <Container maxWidth="md" sx={{ py: { xs: 4, md: 8 }, flexGrow: 1 }}>
        {/* Hero Section */}
        <Fade in timeout={400}>
          <Paper elevation={0} sx={glassStyles}>
            <Stack spacing={3} alignItems="center" textAlign="center">
              <BilldaLogo variant="auto" width={140} />

              <Box
                sx={{
                  width: 72,
                  height: 72,
                  borderRadius: '50%',
                  display: 'grid',
                  placeItems: 'center',
                  bgcolor: isDark
                    ? 'rgba(102, 187, 106, 0.12)'
                    : 'rgba(76, 175, 80, 0.08)',
                  boxShadow: isDark
                    ? '0 0 24px rgba(102, 187, 106, 0.15)'
                    : '0 0 24px rgba(76, 175, 80, 0.1)',
                }}
              >
                <CheckCircleOutlineIcon
                  sx={{ fontSize: 40, color: 'success.main' }}
                />
              </Box>

              <Typography
                variant="h4"
                component="h1"
                fontWeight={700}
                data-testid="download-app-success-title"
              >
                {heading}
              </Typography>

              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ maxWidth: 480 }}
                data-testid="download-app-message"
              >
                {message}
              </Typography>

              {/* App Store Badges — standard official badges */}
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                alignItems="center"
                sx={{ pt: 1 }}
              >
                <Box
                  component="a"
                  href={APP_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="download-app-store-apple"
                  sx={{
                    display: 'inline-flex',
                    transition: 'opacity 0.15s',
                    '&:hover': { opacity: 0.8 },
                  }}
                >
                  <AppStoreBadge />
                </Box>
                <Box
                  component="a"
                  href={PLAY_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="download-app-store-google"
                  sx={{
                    display: 'inline-flex',
                    transition: 'opacity 0.15s',
                    '&:hover': { opacity: 0.8 },
                  }}
                >
                  <GooglePlayBadge />
                </Box>
              </Stack>

              {/* What's next — step cards */}
              <Box
                sx={{
                  width: '100%',
                  textAlign: 'left',
                  pt: 1,
                }}
                data-testid="download-app-steps"
              >
                <Typography
                  variant="overline"
                  color="text.secondary"
                  sx={{ letterSpacing: 1.5, mb: 2, display: 'block' }}
                >
                  What&apos;s next
                </Typography>
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                    gap: 2,
                  }}
                >
                  {STEPS.map((step, index) => {
                    const StepIcon = STEP_ICONS[index];
                    return (
                      <Paper
                        key={index}
                        elevation={0}
                        data-testid={`download-app-step-${index + 1}`}
                        sx={{
                          p: 2.5,
                          borderRadius: 2.5,
                          border: '1px solid',
                          borderColor: 'divider',
                          position: 'relative',
                          bgcolor: isDark
                            ? 'rgba(255, 255, 255, 0.03)'
                            : 'rgba(0, 0, 0, 0.01)',
                        }}
                      >
                        {/* Avatar icon top-right */}
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 12,
                            right: 12,
                            width: 36,
                            height: 36,
                            borderRadius: '50%',
                            display: 'grid',
                            placeItems: 'center',
                            bgcolor: isDark
                              ? 'rgba(144, 202, 249, 0.08)'
                              : 'rgba(25, 118, 210, 0.06)',
                            color: 'primary.main',
                          }}
                        >
                          <StepIcon sx={{ fontSize: 18 }} />
                        </Box>
                        {/* Step number */}
                        <Typography
                          variant="caption"
                          sx={{
                            color: 'primary.main',
                            fontWeight: 700,
                            mb: 0.5,
                            display: 'block',
                          }}
                        >
                          Step {index + 1}
                        </Typography>
                        <Typography
                          variant="body1"
                          fontWeight={600}
                          sx={{ pr: 5 }}
                        >
                          {step.title}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ mt: 0.5, pr: 5 }}
                        >
                          {step.getDescription(email)}
                        </Typography>
                      </Paper>
                    );
                  })}
                </Box>
              </Box>

              {/* Social Links */}
              <Stack direction="row" spacing={1} sx={{ pt: 1 }}>
                {SOCIAL_LINKS.map(({ href, label, path }) => (
                  <IconButton
                    key={label}
                    component="a"
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    size="small"
                    sx={{
                      color: 'text.secondary',
                      '&:hover': { color: 'primary.main' },
                    }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d={path} />
                    </svg>
                  </IconButton>
                ))}
              </Stack>
            </Stack>
          </Paper>
        </Fade>
      </Container>
    </Box>
  );
};

export default DownloadAppPage;
